import { render, staticRenderFns } from "./BonApportCard.vue?vue&type=template&id=3bc1a4fc"
import script from "./BonApportCard.vue?vue&type=script&lang=js"
export * from "./BonApportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports